/* jshint esnext: true */
import AbstractModule from './AbstractModule';

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.$sliderOne = this.$el.find('.js-slider-one');
        this.$sliderTwo = this.$el.find('.js-slider-two');

        this.$category = this.$el.find('.js-category');
        this.$link = this.$el.find('.js-link');

        this.$prevArrow = this.$el.find('.js-prev');
        this.$nextArrow = this.$el.find('.js-next');

        setTimeout(() => {
            this.$sliderTwo.slick(
                {
                    adaptiveHeight: true,
                    accessibility: false,
                    arrows: false,
                    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
                    draggable: false,
                    fade: true,
                    speed: 600,
                    swipe: false
                }
            );

            this.$sliderOne.slick(
                {
                    adaptiveHeight: true,
                    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
                    infinite: false,
                    nextArrow: this.$nextArrow,
                    prevArrow: this.$prevArrow,
                    speed: 600
                }
            ).on('beforeChange init', (event, slick, currentSlide, nextSlide) => {
                if (event.type === 'beforeChange') {
                    // Start by toggling the buttons and the transitionning class
                    this.$prevArrow.toggleClass('is-disabled', nextSlide === 0);
                    this.$nextArrow.toggleClass('is-disabled', nextSlide === slick.slideCount - 1);

                    if (currentSlide !== nextSlide) {
                        let action;
                        if (Math.abs(nextSlide - currentSlide) === 1) {
                            action = (nextSlide - currentSlide > 0) ? 'slickNext' : 'slickPrev';
                        } else {
                            action = (nextSlide - currentSlide > 0) ? 'slickPrev' : 'slickNext';
                        }
                        this.$sliderTwo.slick(action);
                    }
                }

                if (event.type === 'init') {
                    this.$document.trigger('refreshSkrollr.Parallax');
                }
            });
        }, 600);
    }

    destroy() {
        this.$sliderOne.slick('unslick');
        this.$sliderTwo.slick('unslick');
    }
}
